export default __webpack_public_path__ + "static/media/754.ec105d34.png";